// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__1GQX_","inputWrap":"styles_inputWrap__1XKYc","input":"styles_input__2eGtq"};